//
// DiscreteSort.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";
import "@sas-dvr/ltjs-commons/models/data/sorting/SortDirection";
import "./GTLSortUsage";
import "../core/SortOrder";

var DiscreteSort = createModule("gtl::DiscreteSort", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        sortDirection: 4,
        sortByVariable: 7,
        usage: 4,
        customSortValues: [7],
        variable: 7,
        resolveDirection: 2,
    },
    ,
    ,
    {
        getPrimarySortVariable: [7],
        computeSortOrder: [4],
    },
    {
        _create: [4],
    },
    ,
]);
export default DiscreteSort;
